import Box from '@mui/material/Box';
import MuiDialogContent from '@mui/material/DialogContent';
import { SxProps, Theme } from '@mui/material/styles';

type DialogContentProps = {
  sx?: SxProps<Theme>;
};

export default function DialogContent({
  children,
  sx,
}: React.PropsWithChildren<DialogContentProps>) {
  return (
    <MuiDialogContent sx={[{ p: 0 }, ...(Array.isArray(sx) ? sx : [sx])]}>
      <Box sx={{ px: 3, py: 2.5 }}>{children}</Box>
    </MuiDialogContent>
  );
}
